import { render, staticRenderFns } from "./Area2.vue?vue&type=template&id=04e1bcdc&scoped=true&"
import script from "./Area2.vue?vue&type=script&lang=js&"
export * from "./Area2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e1bcdc",
  null
  
)

export default component.exports